import { html, type Html, on, Page } from 'rune-ts';
import klass from './VerifyEmail.module.scss';
import { LayoutView } from '../../components/cells/Layout/LayoutView';
import { footer_links } from '../../components/cells/Footer/constant';
import { UtilImageS } from '../../../../../modules/Util/Image/S/Function/module/UtilImageS';
import { typo } from '../../../shared/typography/typo';
import { ButtonAction } from '../../../shared/components/atoms/ButtonAction/ButtonAction';
import axios from 'axios';
import { Alert } from '../../components/cells/Alert/Alert';
import { BaseLayoutOptions } from '../../../features/Core/service';

export type VerifyEmailPageData = {
  email: string;
  layout_options: BaseLayoutOptions;
};

export class VerifyEmailPage extends Page<VerifyEmailPageData> {
  override onMount() {}

  @on('click', `.${klass.change_button}`)
  async handleChangeEmailClick() {
    const response = await axios.get<{ result: boolean; user: any }>('/@api/get/user');

    // if (!response.data.result)
    //   return $.alert(T('my_info::There is no user information. Please log in again after login.'));

    $.frame.open(
      {
        frame_name: 'mp.checkout.change_email',
        closed: function (X, data) {
          if (!data || !data.result) return;
          window.location.reload();
        },
      },
      {
        tabs: [
          {
            page_name: 'mp.checkout.change_email',
            data_func: function () {
              return data.user;
            },
          },
        ],
      },
    );
  }

  @on('click', `.${klass.resend_button}`)
  async handleResendEmailClick() {
    const search_params = new URLSearchParams(window.location.search.slice(1));
    const { data } = await axios.post('/@api/mp/resend_verification', { url: search_params.get('url') });

    if (data.result) {
      await Alert.open({
        title: ET('mps2::login::email_send_ing'),
        message: html.preventEscape(T('login::Check your email.')),
      });
    } else {
      await Alert.open({
        title: ET('mps2::login::email_error'),
        message: html.preventEscape(T('login::failed please retry')),
      });
    }
  }

  protected override template(data: VerifyEmailPageData): Html {
    const { email, layout_options } = data;
    const { is_mobile } = layout_options;

    const body = html`
      <div class="${klass.body}">
        <img
          class="${klass.image}"
          src="${UtilImageS.getResizedUrl({
            url: '//s3.marpple.co/files/u_1165777/2024/5/original/be4b02e375ce1a412778f28705e8ef053f800b931.png',
            format: 'webp',
            width: 500,
          })}"
          alt="blue mail box"
        />
        <p class="${klass.title} ${typo(is_mobile ? '20_bold' : '24_bold')}">
          ${T('login::Please verify your e-mail address')}
        </p>
        <p class="${klass.description} ${typo(is_mobile ? '12_medium' : '16_medium')}">
          ${ET('mps2::login::email_verify_sent')} <br />
          ${ET('mps2::login::check_email')}
        </p>
        <div class="${klass.email} ${typo('16_medium')}">${email}</div>
        <div class="${klass.buttons}">
          ${new ButtonAction({
            size: is_mobile ? 'medium' : 'large',
            label: ET('mps2::login::change_email'),
            klass: klass.change_button,
            type: 'white',
          })}
          ${new ButtonAction({
            size: is_mobile ? 'medium' : 'large',
            label: ET('mps2::login::resend_email'),
            klass: klass.resend_button,
            type: 'blue',
          })}
        </div>
      </div>
    `;

    return html`
      <div class="${klass.page}">
        ${new LayoutView(
          is_mobile
            ? {
                body,
                footer: '',
              }
            : {
                body,
                footer_data: { ...footer_links, is_mobile, lang: ET.lang },
              },
          {
            ...layout_options,
          },
        )}
      </div>
    `;
  }
}
